import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Guarantee() {
  return <section className="w-full bg-background px-5 py-12 sm:py-20" data-id="element-95" data-mp="1o5zqy212ub4m">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.5
    }} className="mx-auto flex max-w-2xl flex-col items-center rounded-2xl border border-line bg-surface p-8 text-center sm:p-12" data-id="element-96" data-mp="222wiy6sxlyn3">
        <span className="flex h-16 w-16 items-center justify-center rounded-full bg-primary/10 text-primary" data-id="element-97" data-mp="1j4k5w9ywg4m8">
          <ShieldCheckIcon className="h-9 w-9" aria-hidden="true" data-id="element-98" data-mp="1ee3s2or62gzc" />
        </span>
        <h2 className="mt-5 font-display text-2xl font-bold text-foreground sm:text-3xl" data-id="element-99" data-mp="1ec0wzqb5pxnr">
          Garantía de <span className="text-pink" data-id="element-100" data-mp="lp6citecayaa">7 días</span> sin preguntas
        </h2>
        <p className="mt-2 text-sm font-medium text-primary-strong sm:text-base" data-id="element-101" data-mp="ln2a6fw3a7c4">
          Tu inversión está protegida
        </p>
        <div className="mt-6 space-y-4 text-sm leading-relaxed text-muted sm:text-base" data-id="element-102" data-mp="tycqkguuh9rf">
          <p data-id="element-103" data-mp="ypb7ninnqbvq">
            Accedé al método completo, revisá los 6 módulos y los 4 bonos y empezá a estudiar.
          </p>
          <p data-id="element-104" data-mp="12rg3mo1kvklj">
            Si dentro de los primeros 7 días sentís que no es para vos, te devolvemos el 100% de tu
            dinero. Sin preguntas. Sin trámites complicados.
          </p>
          <p className="font-semibold italic text-foreground" data-id="element-105" data-mp="azh0nhq0rhje">
            El riesgo es cero. La decisión es tuya.
          </p>
        </div>
        <div className="mt-8 w-full max-w-md" data-id="element-106" data-mp="ezsgmh7fstoj">
          <CTAButton data-id="element-107" data-mp="k06q83oosboo" />
          <p className="mt-3 text-xs text-muted sm:text-sm" data-id="element-108" data-mp="k0otvldohs6m">
            Precio en USD · Pagás en tu moneda local · Acceso por mail
          </p>
        </div>
      </motion.div>
    </section>;
}